import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { Identifier, SupportedIdentifiers } from 'types/types';

interface IdInputProps {
  onChange: ({ id, type }: Identifier) => void;
  value: Identifier;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  inputProps?: any;
}

export default function IdInput({
  onChange,
  value,
  helperText,
  error,
  disabled,
  inputProps,
}: IdInputProps) {
  const { t } = useTranslation();

  const IDCards = [
    {
      id: SupportedIdentifiers.taj,
      name: t(`general.idTypes.${SupportedIdentifiers.taj}`),
    },
    {
      id: SupportedIdentifiers.other,
      name: t(`general.idTypes.${SupportedIdentifiers.other}`),
    },
    {
      id: SupportedIdentifiers.none,
      name: t(`general.idTypes.${SupportedIdentifiers.none}`),
    },
  ];

  return (
    <Box width="100%">
      <Box display="flex" flexDirection="row" alignItems="center" mt={1}>
        <FormControl sx={{ width: '40%', mr: 1 }}>
          <InputLabel>{t('general.identifierType')}</InputLabel>
          <Select
            inputProps={{ ...inputProps }}
            value={value.type}
            label={t('general.identifierType')}
            name="type"
            error={error}
            onChange={evt => {
              const type = evt.target.value as SupportedIdentifiers;
              onChange({
                id: type === SupportedIdentifiers.none ? '' : value.id,
                type: type,
              });
            }}
          >
            {IDCards.map(item => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          fullWidth
          label={t('general.identifier')}
          name="id"
          value={value.id}
          disabled={value.type === SupportedIdentifiers.none}
          onChange={evt => {
            onChange({ id: evt.target.value, type: value.type });
          }}
          error={error}
          inputProps={{ ...inputProps }}
        />
      </Box>
      {error && (
        <FormHelperText error={error} sx={{ width: '100%' }}>
          {helperText}
        </FormHelperText>
      )}
    </Box>
  );
}
